import api from "./api";

export interface Medicine {
  _id: string;
  code: string;
  name: string;
  genericName?: string;
  category: string;
  manufacturer: string;
  hsnCode?: string;
  defaultGstRate: number;
  schedule: string;
  /** Stock / sale unit (inventory) */
  unit: string;
  /** Supplier invoice unit */
  purchaseUnit?: string;
  /** Base units per 1 purchase unit */
  packSize: number;
  reorderLevel: number;
  /** Per purchase unit (strip/box) */
  defaultMrp: number;
  defaultSellingPrice: number;
  barcode?: string;
  isActive: boolean;
  notes?: string;
}

const medicineService = {
  getAll: (params?: Record<string, any>) =>
    api.get("/medicines", { params }),
  getById: (id: string) => api.get(`/medicines/${id}`),
  create: (data: Partial<Medicine>) => api.post("/medicines", data),
  update: (id: string, data: Partial<Medicine>) =>
    api.put(`/medicines/${id}`, data),
  remove: (id: string) => api.delete(`/medicines/${id}`),
};

export default medicineService;
